import {
    FETCH_OPEN_ACTIVITY_DIARIES_REQUEST_SUCCESS,
    //VALIDATE_ACTIVITY_FOR_CLOSE_ACTION_REQUEST_SUCCESS,
    FETCH_ACTIVITY_NOTIFICATION_REQUEST_SUCCESS,
    CLOSE_ACTIVITY_VALIDATION_ERROR_MESSAGE,
    CLOSE_ACTIVITY_ACTION_DENIED_ERROR_MESSAGE,
    CLOSE_ACTIVITY_RESET_STATE
} from '../actions/actionConstants';


const initialState = {
    errorMsg: null,
    actionDeniedMsg:null,

    diariesData: {
        count: 0,
        data: []
    },
    notificationData: {
        count: 0,
        data: []
    }
};

export default function (state = initialState, action) {
    switch (action.type) {

        case FETCH_OPEN_ACTIVITY_DIARIES_REQUEST_SUCCESS: {
            const diariesData = {
                count: action.payload.count,
                data: action.payload.data
            }

            return Object.assign(
                {},
                state,
                {
                    diariesData
                }
            );
        }

        case FETCH_ACTIVITY_NOTIFICATION_REQUEST_SUCCESS: {

            const notificationData = {
                count: action.payload.actCount,
                data: action.payload.data
            }

            return Object.assign(
                {},
                state,
                {
                    notificationData
                }
            );
        }
        case CLOSE_ACTIVITY_VALIDATION_ERROR_MESSAGE:
            return Object.assign(
                {},
                state,
                {
                    errorMsg: action.payload
                }
            );
        case CLOSE_ACTIVITY_ACTION_DENIED_ERROR_MESSAGE:
            return Object.assign(
                    {},
                    state,
                    {
                        actionDeniedMsg: action.payload
                    }
            );    
        case CLOSE_ACTIVITY_RESET_STATE:
            return initialState;

        default:
            return state;
    }
}